import { Meta } from "@/shared/components";
import { Subscriptions } from "@/admin/features/subscriptions";

export function SubscriptionsPage() {
  return (
    <>
      <Meta title="Подписки" />
      <Subscriptions />
    </>
  );
}
